import { render, staticRenderFns } from "./Models-Single-GameGroups.vue?vue&type=template&id=ef3d1d60&scoped=true"
import script from "./Models-Single-GameGroups.js?vue&type=script&lang=js&external"
export * from "./Models-Single-GameGroups.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef3d1d60",
  null
  
)

export default component.exports